<template>
  <div id="app">
    <b-navbar toggleable="lg" type="light" variant="light">
      <b-navbar-brand :to="{ name: 'home' }">
        <img src="../../assets/inova-logo.png" alt="inova" height="30" width="70" />
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item-dropdown v-for="group in getGroups" :key="group.groupId">
            <template v-slot:button-content>{{ group.name }}</template>
            <Dropdown :group="group"></Dropdown>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item :to="{ name: 'home' }">Home</b-nav-item>
          <b-nav-item v-if="loggedIn && userIsAdmin" :to="{ name: 'todo' }">Todo-App</b-nav-item>
          <b-nav-item v-if="!loggedIn" :to="{ name: 'login' }">Login</b-nav-item>
          <b-nav-item v-if="loggedIn && userIsAdmin" :to="{ name: 'register' }">Registrar</b-nav-item>
          <b-nav-item v-if="loggedIn && userIsAdmin" :to="{ name: 'accounts' }">Usuários</b-nav-item>
          <b-nav-item v-if="loggedIn && userIsAdmin" :to="{ name: 'profiles' }">Perfis de Acesso</b-nav-item>
          <b-nav-item v-if="loggedIn" :to="{ name: 'changePassword' }">Alterar Senha</b-nav-item>
          <b-nav-item v-if="loggedIn" :to="{ name: 'logout' }">Logout</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <router-view></router-view>
    <h5 id="token-usage" v-if="loggedIn && userIsAdmin">Uso de Tokens: {{tokenUsage}}%</h5>
  </div>
</template>

<script>
import Dropdown from "./Dropdown";

export default {
  components: {
    Dropdown
  },
  computed: {
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
    getGroups() {
      return this.$store.getters.getGroups;
    },
    userIsAdmin() {
      return this.$store.getters.userIsAdmin;
    },
    tokenUsage() {
      const availableFeatures = this.$store.getters.getAvailableFeatures;
      if(availableFeatures){
        const embedTrialUsage = availableFeatures.features.filter(feature => feature.name === 'embedTrial')[0]
        if(embedTrialUsage) {
          return embedTrialUsage.additionalInfo.usage;
        }
      }
      return 'XX';
    }
  },
  created() {
    if (this.loggedIn){
      if(!this.$store.getters.getCurrentUser) {
        this.$store.dispatch("getCurrentUser");
      }
      this.$store.dispatch("retrieveAvailableFeatures");
      this.$store.dispatch("retrieveGroups");
    }
  }
};
</script>

<style>
.navbar-brand {
  padding-top: 0;
  padding-bottom: 0;
}

#token-usage {
  text-align: end;
  margin-right: 1em;
}
</style>